module.exports = __webpack_public_path__ + "assets/1-Phoenix-AE-Tech-Jobs.4432af83.png";